angular.module('zc.zenclerkS')
  .controller('ZcsNewImageController', ZcsNewImageController);

ZcsNewImageController.$inject = ['$scope', '$stateParams', 'Devise', 'ZcsImage', 'ZcsProject'];
function ZcsNewImageController($scope, $stateParams, Devise, ZcsImage, ZcsProject) {
  Devise.getCurrentUser()
    .then(currentUser => ZcsProject.get(currentUser.id, $stateParams.apikey)).then(project =>
      $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
        event.preventDefault();
        return ZcsImage.create({
          projectId: project.id
        }, {
          image: flowFile.file
        }).then(res => {
          $scope.campaign.userPattern = true;
          $scope.campaign.element.message[$scope.itemName] = _.get(res, 'data.image.image_url');
        }).catch(err => console.error(err));
      })
    );
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/template_editor/new_image.controller.js